import * as _ from 'lodash';
import { Component, FormEvent } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, ITransplantedPatientsResponse } from '@nkr/store/index';
import { Button, FormControl, Row } from 'react-bootstrap';
import { ITransplantedPatients } from '@nkr/models/index';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getTransplantedPatients: (centerId: number) => Promise<ITransplantedPatientsResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    report: ITransplantedPatients[],
    filterCenterId: number
}

class TransplantedPatients extends Component<TProps, IState> {
    readonly state: IState = {
        report: [],
        filterCenterId: 0
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getTransplantedPatients(this.props.centerId)
                .then((response: ITransplantedPatientsResponse) => {

                    if (response.data.success) {
                        this.setState({
                            report: response.data.results
                        });
                    }

                    this.props.hideLoading();
                })
                .catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            fileName: 'transplanted-patients.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            filterCenterId: parseInt(e.currentTarget.value)
        });
    }

    render = () => {
        let centerList = _.sortBy(_.uniqBy(this.state.report.map(x => {
            return {
                id: x.recipientCenterId,
                alias: x.recipientCenterAlias
            };
        }), x => x.id), x => x.alias);

        let filteredList = this.state.report.filter(x => {
            let center = this.state.filterCenterId > 0 ? x.recipientCenterId == this.state.filterCenterId : true;
            return center;
        });

        return (
            <>
                <div style={{ marginBottom: 20, display: 'flex', justifyContent: this.props.centerId == 0 ? 'space-between' : 'flex-end', alignItems: 'center' }}>
                    {this.props.centerId == 0 && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Filter by Center:</div>
                            <div>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.filterCenterId}
                                    onChange={this.handleCenterChange}
                                >
                                    <option value={0}>- All Centers -</option>
                                    {centerList.map(item =>
                                        <option value={item.id}>{item.alias}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>
                    )}
                    <Button onClick={this.handleExport}> Export to CSV </Button>
                </div>

                <Grid
                    data={filteredList}
                    isAdminOnly={this.props.isCenterLogin == false}
                    onGridReady={this.onGridReady}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getTransplantedPatients: (centerId) => {
            return dispatch(ReportActionCreators.getTransplantedPatients(centerId));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(TransplantedPatients);

